import React from 'react';
export function StoryCta() {
  return <section className="w-full bg-brand-navy py-12 md:py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-394" data-mp="3brx6ladzxmyp">
      <div className="max-w-4xl mx-auto" data-id="element-395" data-mp="2r3685qr2w1v6">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-396" data-mp="2d46tnbxa53cq">
          Want to talk?
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-397" data-mp="2i1ymq99nuvii">
          I'm always up for a conversation about your team, AI adoption, or
          leadership. No agenda required.
        </p>
        <div className="flex flex-col items-center space-y-6" data-id="element-398" data-mp="286501x289ln0">
          <a href="#/contact/book" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm w-full sm:w-auto" data-id="element-399" data-mp="1uei2ltwju72n">
            Book a Call
          </a>
          <p className="text-white text-base" data-id="element-400" data-mp="1pduebfzpg4c4">
            Or email me directly:{' '}
            <a href="mailto:michael@breakapencil.com" className="text-white border-b-2 border-brand-orange hover:text-brand-orange transition-colors pb-0.5" data-id="element-401" data-mp="31aenqmtq5xfz">
              michael@breakapencil.com
            </a>
          </p>
        </div>
      </div>
    </section>;
}